export const FarmerProductIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 21H17"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12H3C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21Z"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.38 12C10.7744 12.0056 10.189 11.7821 9.74129 11.3742C9.29358 10.9663 9.01665 10.4042 8.96604 9.80066C8.91543 9.19711 9.09488 8.59675 9.4684 8.11998C9.84193 7.64321 10.3819 7.3253 10.98 7.23C10.8843 6.80623 10.9053 6.36441 11.041 5.95167C11.1766 5.53893 11.4218 5.17075 11.7502 4.88641C12.0787 4.60206 12.4782 4.41222 12.9061 4.33712C13.3341 4.26203 13.7743 4.3045 14.18 4.46C14.3576 4.18036 14.5913 3.94053 14.8661 3.7556C15.141 3.57067 15.4512 3.44465 15.7771 3.38547C16.1031 3.32629 16.4378 3.33523 16.7601 3.41174C17.0824 3.48824 17.3854 3.63065 17.65 3.83C18.1116 3.46722 18.6901 3.28621 19.2761 3.32119C19.8621 3.35618 20.415 3.60475 20.8301 4.01987C21.2453 4.43499 21.4938 4.98787 21.5288 5.57389C21.5638 6.15991 21.3828 6.73844 21.02 7.2C21.2458 7.49993 21.3981 7.84865 21.4646 8.21813C21.5312 8.58761 21.5101 8.96755 21.4031 9.32741C21.2961 9.68727 21.1062 10.017 20.8486 10.2901C20.5911 10.5633 20.273 10.7721 19.92 10.9C20.0113 11.2599 20.0215 11.6356 19.95 12"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 12L17 8"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9 7.25C10.3515 6.66527 9.63954 6.25934 8.85697 6.08512C8.07439 5.9109 7.25748 5.97648 6.51272 6.27331C5.76796 6.57013 5.12989 7.08443 4.68169 7.74918C4.23348 8.41392 3.99593 9.19828 3.99999 10C3.99999 10.73 4.19999 11.41 4.53999 12"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
